'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserMenuWidget = function UserMenuWidget(props) {
    var theme = props.theme,
        userMenu = props.userMenu;


    return _react2.default.createElement(
        'ul',
        { className: theme.userMenuInner },
        userMenu.userMenuWidget.map(function (item) {
            return _react2.default.createElement(
                'li',
                { key: item.name, className: theme.userItem },
                _react2.default.createElement(
                    'a',
                    { className: theme.userLink, href: item.url },
                    item.name
                )
            );
        })
    );
};

UserMenuWidget.propTypes = {
    theme: _propTypes2.default.shape({
        userMenuInner: _propTypes2.default.string,
        userItem: _propTypes2.default.string,
        userLink: _propTypes2.default.string
    }).isRequired,
    userMenu: _propTypes2.default.shape({
        userMenuWidget: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            name: _propTypes2.default.string,
            url: _propTypes2.default.string
        }))
    }).isRequired
};

exports.default = UserMenuWidget;
//# sourceMappingURL=UserMenuWidget.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/cn-skin-vg/lib/cjs/widgets/UserMenuWidget.js
 ** module id = 714
 ** module chunks = 1
 **/